import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import * as fileSaver from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { IFilterSolicitudModel } from 'src/app/models/interfaces/solicitud/IFilterSolicitudModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { FilterSolicitudModel } from 'src/app/models/solicitud/FilterSolicitudModel';
import { SolicitudAccesoResultadoModel, SolicitudAutorizarAccesoModel } from 'src/app/models/solicitud/SolicitudAutorizarAccesoModel';
import { SolicitudResultadoBusqueda } from 'src/app/models/solicitud/solicitudResultadoBusqueda';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';
import { SolicitudPendienteAccesoDetalleDialogComponent } from '../solicitud-pendiente-acceso-detalle-dialog/solicitud-pendiente-acceso-detalle-dialog.component';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-solicitud-pendiente-acceso-lista',
  templateUrl: './solicitud-pendiente-acceso-lista.component.html',
  styleUrls: ['./solicitud-pendiente-acceso-lista.component.css']
})
export class SolicitudPendienteAccesoListaComponent implements OnInit {
  modelFilter: IFilterSolicitudModel;
  modelListaSolicitudes: SolicitudResultadoBusqueda[] =
  new Array<SolicitudResultadoBusqueda>();
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  
  checkTodosAutorizados: boolean = false;
  checkTodosRechazados: boolean = false;

  resultsLength = 0;
  currentPage = 0;
  
  displayedColumns: string[] = [
    'codigo',
    'compania',
    'contratista',
    'sede',
    'trabajo',
    'fechaInicio',
    'fechaFin',
    'solicitante',
    'aprobado',
    'desaprobado',
    'acciones',
  ];
  
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    public dialog: MatDialog,
    private solicitudService: SolicitudService,
    private confirmDialogService: ConfirmDialogService,
    private sedeService: SedeService,
    private storage: StorageService,
    private alertDialogService: AlertDialogService,
  ) { 
    let usuario = this.storage.getCurrentUser();
    this.modelFilter = new FilterSolicitudModel();
    this.listaCompanias = usuario.companias;
    this.modelFilter.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.modelFilter.pageSize = 30;   
    this.companiaChanged();

    this.search();
  }

  companiaChanged() {

    this.listaSedes = [];
    this.modelFilter.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.modelFilter.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  addDays(currentDate: Date, days : number): Date{
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  registrarResultados(): void {
    this.confirmDialogService.open('¿Está seguro de enviar la información?'); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        let listaResultados = new SolicitudAutorizarAccesoModel();
        listaResultados.listaSolicitudes = this.modelListaSolicitudes.filter(p => p.autorizado || p.rechazado).map((p) => {
          let resultado = new SolicitudAccesoResultadoModel();
          resultado.idSolicitud = p.idSolicitud;
          resultado.autorizado = p.autorizado;
          resultado.rechazado = p.rechazado;
          return resultado;
        });

        this.solicitudService.autorizar(listaResultados).subscribe((result : ActionResultModel) => {
          //console.log(result);
          this.search();
          if(result.type!=eTypeResult.SUCCESS){
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  search(): void {
    this.modelFilter.page = 1;

    this.solicitudService.getListPendienteAutorizacion(this.modelFilter).subscribe((data) => {
      this.modelListaSolicitudes = data.items;
      this.resultsLength = data.total;
      this.currentPage = 0;
        this.paginator.firstPage();
    });
  }

  getPaginatorData(event: any) {
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.solicitudService
      .getListPendienteAutorizacion(this.modelFilter)
      .subscribe((data) => {
        this.modelListaSolicitudes = data.items;
        this.resultsLength = data.total;
      });
  }

  changeAutorizado(element: SolicitudResultadoBusqueda){    
    if(element.autorizado)
      element.rechazado = false;
  }

  changeRechazado(element: SolicitudResultadoBusqueda){    
    // element.aprobado = !element.observado;
    if(element.rechazado)
      element.autorizado = false;
  }

  changeAutorizadoAll(item: any){    
    console.log(item);    
    if(item.checked){
      this.checkTodosRechazados = false;
      this.modelListaSolicitudes.forEach(element => {        
        element.rechazado = false 
        element.autorizado = item.checked;
      });
    }
    else {
      this.modelListaSolicitudes.forEach(element => {
        element.autorizado = item.checked;
      });
    }
  }

  changeRechazadoAll(item: any){    
    console.log(item);
    
    if(item.checked){
      this.checkTodosAutorizados = false;
      this.modelListaSolicitudes.forEach(element => {
        element.autorizado = false;
        element.rechazado = item.checked;         
      });
    }
    else {
      this.modelListaSolicitudes.forEach(element => {
        element.rechazado = item.checked;         
      });
    }
  }

  esInvalido(): boolean{
    return this.modelListaSolicitudes.filter(p => p.autorizado || p.rechazado).length == 0;
  }

  openDialogDetalle(solicitud: SolicitudResultadoBusqueda): void {
    // if(!extensionModel)
    // console.log(solicitud);
    
    const dialogRef = this.dialog.open(SolicitudPendienteAccesoDetalleDialogComponent, {
      width: '800px',
      data: solicitud.idSolicitud
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.search();
    });
  }

  export() {
    this.modelFilter.page = 1;
    this.solicitudService.getListPendienteAutorizacionToExport(this.modelFilter).subscribe(
      (data) => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        fileSaver.saveAs(blob, `pendiente-autorizar-${Date.now()}.xlsx`);
      },
      (error) => {
      }
    );
  }
}
